import {
  Box,
  Collapse,
  ListItemButton as ListItemButtonMui,
  ListItemText as ListItemTextMui,
  Stack,
} from "@mui/material";

import { useState } from "react";
import { styled } from "@mui/material/styles";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";

export const ListSectionVertical = ({ listConfig, active, handleActive }) => {
  return (
    <Stack spacing="8px">
      {listConfig.map((item, i) => (
        <ListRoot key={i} active={active} handleActive={handleActive} item={item} />
      ))}
    </Stack>
  );
};

export const ListRoot = ({ active, handleActive, item }) => {
  const hasChildren = item?.children;
  const [open, setOpen] = useState(false);
  if (hasChildren) {
    return (
      <Box>
        <ListItemRoot
          active={active}
          item={item}
          open={open}
          onOpen={() => setOpen(!open)}
          handleActive={undefined}
        />
        <Collapse in={open}>
          {(item.children || []).map((itemSub) => (
            <ListItemSub
              key={itemSub.title}
              active={active}
              handleActive={handleActive}
              item={itemSub}
            />
          ))}
        </Collapse>
      </Box>
    );
  }
  return <ListItemRoot active={active} handleActive={handleActive} item={item} />;
};

type ListItemButtonProps = {
  isActive: boolean;
};

export const ListItemButton = styled(ListItemButtonMui)<ListItemButtonProps>(() => ({
  borderRadius: "4px",
  padding: "4px 12px",
  color: "#616161",
  "&:hover": {
    backgroundColor: "#E0E0E0",
  },
}));

export const ListItemButtonRoot = styled(ListItemButton)(({ isActive = false, theme }) => ({
  ...(isActive && {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
  }),
}));

export const ListItemButtonSub = styled(ListItemButton)(({ isActive = false, theme }) => ({
  ...(isActive && {
    color: theme.palette.primary.main,
  }),
}));

export const ListItemText = styled(ListItemTextMui)(() => ({
  margin: 0,
  "& .MuiTypography-root": {
    fontSize: "1rem",
  },
  whiteSpace: "pre-line",
}));

export const ListItemRoot = ({ active, handleActive, item, open = false, onOpen = () => {} }) => {
  const { title, id, children, isNew } = item;
  if (children) {
    return (
      <ListItemButtonRoot onClick={onOpen} isActive={children.some((i) => i.id === active)}>
        <ListItemText primary={title} />
        {isNew && <ChipNew />}
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButtonRoot>
    );
  }
  return (
    <ListItemButtonRoot onClick={() => handleActive(id)} isActive={active === id}>
      <ListItemText primary={title} />
      {isNew && <ChipNew />}
    </ListItemButtonRoot>
  );
};

export const ListItemSub = ({ active, handleActive, item }) => {
  const { title, id } = item;
  return (
    <ListItemButtonSub onClick={() => handleActive(id)} isActive={active === id}>
      <ListItemText primary={title} sx={{ pl: "20px" }} />
    </ListItemButtonSub>
  );
};

const ChipNew = () => {
  const { t } = useTranslation(["translation", "newFeature"]);
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      sx={{ backgroundColor: "#F4B000", borderRadius: "4px", color: "#FFFFFF", padding: "1px 4px" }}
    >
      <Box sx={{ fontSize: "0.688rem", fontWeight: 600, lineHeight: "20px" }}>{t("new")}</Box>
    </Stack>
  );
};
